var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21C7.93641 21 7.39591 20.7787 6.9974 20.3849C6.59888 19.9911 6.375 19.457 6.375 18.9H10.625C10.625 19.457 10.4011 19.9911 10.0026 20.3849C9.60409 20.7787 9.06359 21 8.5 21ZM17 17.85H0V15.75L2.125 14.7V8.925C2.125 5.2899 3.63481 2.93265 6.375 2.289V0H9.5625C8.8697 0.907134 8.49652 2.0135 8.5 3.15C8.5 3.41355 8.52019 3.6771 8.5595 3.93855H8.5C7.86199 3.89771 7.22379 4.01557 6.64376 4.28136C6.06373 4.54714 5.56036 4.95237 5.17969 5.46C4.51833 6.49378 4.19383 7.7032 4.25 8.925V15.75H12.75V8.925C12.75 8.70345 12.7426 8.4903 12.7277 8.295C13.4305 8.43845 14.1553 8.44095 14.8591 8.30235C14.8708 8.5239 14.875 8.73495 14.875 8.93235V14.7L17 15.75V17.85ZM13.8125 6.3C12.9671 6.3 12.1564 5.96813 11.5586 5.37739C10.9608 4.78665 10.625 3.98543 10.625 3.15C10.625 2.31457 10.9608 1.51335 11.5586 0.922614C12.1564 0.331874 12.9671 0 13.8125 0C14.6579 0 15.4686 0.331874 16.0664 0.922614C16.6642 1.51335 17 2.31457 17 3.15C17 3.98543 16.6642 4.78665 16.0664 5.37739C15.4686 5.96813 14.6579 6.3 13.8125 6.3Z",
    fill: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8389_15294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21C7.93641 21 7.39591 20.7787 6.9974 20.3849C6.59888 19.9911 6.375 19.457 6.375 18.9H10.625C10.625 19.457 10.4011 19.9911 10.0026 20.3849C9.60409 20.7787 9.06359 21 8.5 21ZM17 17.85H0V15.75L2.125 14.7V8.925C2.125 5.2899 3.63481 2.93265 6.375 2.289V0H9.5625C8.8697 0.907134 8.49652 2.0135 8.5 3.15C8.5 3.41355 8.52019 3.6771 8.5595 3.93855H8.5C7.86199 3.89771 7.22379 4.01557 6.64376 4.28136C6.06373 4.54714 5.56036 4.95237 5.17969 5.46C4.51833 6.49378 4.19383 7.7032 4.25 8.925V15.75H12.75V8.925C12.75 8.70345 12.7426 8.4903 12.7277 8.295C13.4305 8.43845 14.1553 8.44095 14.8591 8.30235C14.8708 8.5239 14.875 8.73495 14.875 8.93235V14.7L17 15.75V17.85ZM13.8125 6.3C12.9671 6.3 12.1564 5.96813 11.5586 5.37739C10.9608 4.78665 10.625 3.98543 10.625 3.15C10.625 2.31457 10.9608 1.51335 11.5586 0.922614C12.1564 0.331874 12.9671 0 13.8125 0C14.6579 0 15.4686 0.331874 16.0664 0.922614C16.6642 1.51335 17 2.31457 17 3.15C17 3.98543 16.6642 4.78665 16.0664 5.37739C15.4686 5.96813 14.6579 6.3 13.8125 6.3Z",
    fill: "#9E9E9E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8389_15294)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 3,
    r: 4,
    fill: "#F3C74C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8f4814010c2222370dcc94b00838f876.svg";
export { ForwardRef as ReactComponent };